import {SelectWithoutContainer} from "../Select/Select";
import {useEffect, useState} from "react";
import Loading from "../Loading/Loading";
import {getAllTownObject} from "../../pages/Towns/functions";
import  {TextInputWithoutContainer} from "../TextInput/TextInput";
import uploadPlaceholder from "../../assets/upload-file.svg";
import ImageInput from "../ImageInput/ImageInput";
import {baseImagesUrl} from "../../assets/Constants";
import NeshanMap from "./NeshanMap/NeshanMap";


const AddressForm = ({address, onChange}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [allTowns, setAllTowns] = useState([]);
    const changeAddress = (key, value) => {
        const newAddress = {...address, [key]: value};
        onChange(newAddress)
    }

    useEffect(() => {
        (async () => {
            const allTowns = await getAllTownObject();
            setAllTowns(allTowns);
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>

    return (
        <div className={"row align-items-center"}>

            <div className="col-md-3">
                <SelectWithoutContainer label={"شهر/ روستا"} options={allTowns} value={address.townId}
                                        onChange={(value) => {
                                            changeAddress("townId", value);
                                        }}/>
            </div>
            <div className="col-md-7">
                <TextInputWithoutContainer label={"آدرس"} value={address.address} onChange={(value) => {
                    changeAddress("address", value);
                }}/>
            </div>
            <div className="col-md-2">
                <label className="card-title mb-2">تصویر محل</label>
                <ImageInput
                    defaultPic={address.picture ? (address.picture.includes("person") ? `${baseImagesUrl}address/${address.picture}` : address.picture) : uploadPlaceholder}
                    onChange={(value) => {
                        changeAddress("picture", value)
                    }}/>
            </div>

            <div className="col-12 my-2">
                <NeshanMap markedLocation={address.location} onChange={(value)=>{
                    const newLocation = {
                        lat : value[0],
                        lng : value[1]
                    }
                    changeAddress("location", newLocation)
                }} />
            </div>

        </div>
    );
}

export default AddressForm;